/* eslint-disable sort-keys */
export default {
  light: {
    "missing-information-account-number-label": "neutral-300",
    "missing-information-error": "tertiary-500",
    "missing-information-link-gray": "neutral-300",
    "missing-information-link-separator": "neutral-500",
    "missing-information-success": "success-500",
    "password-validation-message": "neutral-200",
    "password-validation-message-error": "tertiary-500",
    "password-validation-message-valid": "success-500",
  },
  dark: {
    "missing-information-account-number-label": "neutral-300",
    "missing-information-error": "danger-500",
    "missing-information-link-gray": "neutral-300",
    "missing-information-link-separator": "neutral-500",
    "missing-information-success": "success-500",
    "password-validation-message": "primary-900",
    "password-validation-message-error": "danger-500",
    "password-validation-message-valid": "success-600",
  },
};
